import moment from 'moment'

export const isTokenExpired = (date: moment.MomentInput): boolean => {
  return !moment(date).isAfter()
}
